import { WEB_ASSETS } from '@tenfour/contracts'
import { WORKSPACE_ART, type WorkspaceArtKind } from './workspace-art'
import s from './WorkspaceEmptyArtwork.module.css'

/** The three original clay objects and their circular ground, exactly as the
 * current Feedback compositions arrange them. The parent owns the meaning. */
export function WorkspaceEmptyArtwork({ kind }: { kind: WorkspaceArtKind }) {
  const art = WORKSPACE_ART[kind]
  return <span className={`${s.board} ${s[art.layout]}`} data-workspace-art={kind} aria-hidden="true">
    <span className={s.ground} />
    {art.objects.map((key, index) => {
      const asset = WEB_ASSETS.icons.workspaceObjects[key]
      return <img key={`${key}:${index}`} className={`${s.object} ${s[`object${index}`]}`} src={asset.oneX} srcSet={`${asset.oneX} 1x, ${asset.twoX} 2x`} width={256} height={256} alt="" draggable={false} decoding="async" />
    })}
  </span>
}
